import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {Path} from '../common/path';
import {RestResult} from '../models/response/rest-result';
import {CommonService} from './common.service';
import {SearchRequest} from '../models/request/search-request';
import {SosQuestionRequest} from '../models/request/sos/sos-question-request';

@Injectable()
export class SosQuestionService {

  constructor(protected http: HttpClient,
              protected commonService: CommonService) {
  }

  getOne(sosQuestionId: number): Observable<RestResult> {
    return this.http.get<any>(
      Path.API_ENDPOINT +
      Path.SOS_QUESTION +
      Path.SOS_QUESTION_ID.replace(':sosQuestionId', sosQuestionId.toString())
    ).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError)
    );
  }


  search(request: SearchRequest): Observable<RestResult> {
    return this.http.post<any>(
      Path.API_ENDPOINT +
      Path.SOS_QUESTION +
      Path.SEARCH, request
    ).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError)
    );
  }

  create(request: SosQuestionRequest): Observable<RestResult> {
    return this.http.post<any>(
      Path.API_ENDPOINT +
      Path.SOS_QUESTION, request).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError)
    );
  }

  remove(sosQuestionId: number): Observable<RestResult> {
    return this.http.delete<any>(
      Path.API_ENDPOINT +
      Path.SOS_QUESTION +
      Path.SOS_QUESTION_ID.replace(':sosQuestionId', sosQuestionId.toString())
    ).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError)
    );
  }

  update(request: SosQuestionRequest): Observable<RestResult> {
    return this.http.put<any>(
      Path.API_ENDPOINT +
      Path.SOS_QUESTION, request).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError)
    );
  }
}
